export const DIAS_RESTANTES_CAMBIOS_FECHA = 89 
export const DIAS_RESTANTES_CAMBIO_PASAJERO = 90
export const DIAS_PERMITIR_VIGENCIA_FECHA = 6
export const catCotizador = Object.freeze({
    PORCENTAJE_MENSUALIDAD_HIBRIDO: 0.50,
    PORCENTAJE_TARJETA_CREDITO_HIBRIDO: 0.50,
    CANTIDAD_PAGOS_HIBRIDO: 3,
    CANTIDAD_DIAS_TARJETA_CREDITO: 15,
    CANTIDAD_PAGOS_ADIFERIR: 3,
})
